// import components
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

// import hooks
import { useGetDutyHistoryColumns } from '../hooks/useGetDutyHistoryColumns';
import useGetDutyLinesAudit from '../hooks/useGetDutyLinesAudit';

// import types
import type { DutyHistoryAuditProps } from './DutyHistoryAudit.types';

const DutyHistoryAudit = ({
  isOpen,
  row,
  employeeId
}: DutyHistoryAuditProps) => {
  const columns = useGetDutyHistoryColumns();
  const { data: dutyLineAudit } = useGetDutyLinesAudit(
    {
      employeeId,
      requestId: row?.dutyLineId
    },
    {
      enabled: !!isOpen && !!employeeId && !!row?.requestId
    }
  );

  if (!row && !dutyLineAudit) return null;

  return (
    <TableCRUDLayout
      getRowId={(row) => row?.audit?.auditId}
      columns={columns}
      rows={dutyLineAudit ?? []}
      disableActions
      pageSize={10}
    />
  );
};

export default DutyHistoryAudit;
